import cn from 'classnames';
import { PlateElement, type PlateElementProps } from 'platejs/react';

import styles from './CodeBlockElement.module.scss';

export function CodeBlockElement(props: PlateElementProps) {
	return <PlateElement as="pre" className={cn(styles.code, props.className)} {...props} />;
}
